import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FiltroRol } from "./logic";
import { createSelectorRx } from "keautils";
type Entity = FiltroRol;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un FiltroRol
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroRolComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const SiNo = getField(selectores.SiNo);

        return (
            <div>
                {kea.autogrid(3, [
                    <Text field="busqueda" label="Búsqueda" disableFastInput />,
                    <SiNo field="habilitados" label="Habilitado" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/componentes/filtro.tsx